
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"17"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h16v16H0z"}}),_c('path',{attrs:{"stroke":"#A5A5A5","d":"M7.356 2.058s-3.43.533-3.634 3.997v3.473c.009.276-.047.55-.162.8-.213.357-.556.915-.556.915s-.63.974.43 1.118h9.355s1.407.13.775-1.161l-.776-1.11a1.09 1.09 0 01-.137-.616l-.032-3.462s-.332-3.583-3.81-3.967a5.178 5.178 0 00-1.453.013zm-.852 10.31s.2 1.629 1.599 1.629c.447.029.886-.13 1.213-.438.328-.309.513-.74.513-1.191H6.504z"}})])])
      }
    
      }
    